module.exports = __webpack_public_path__ + "static/media/doc-pdf.ce22f48b.svg";